<template>
  <div class="account__item account__item--edit account__item--gradient">
    <form-factory
      formclass="account__content"
      :record="localAccount"
      :schema="formFields"
      :layout="layout"
      :hasError="error"
      :submitText="getUiString(['my_account', 'contact_info', 'save_button_text'])"
      :cancelText="getUiString(['my_account', 'contact_info', 'cancel_button_text'])"
      @blurfield="checkAddress"
      @submit="saveSettings"
      @reset="$emit('cancel-edit-account')"
    >
      <h2 class="title--l">{{ getUiString(['my_account', 'contact_overview', 'title']) }}</h2>
      <template v-slot:bottomtext>
        <div
          class="text text--emphasis"
        >{{ getUiString(['my_account', 'contact_info', 'bottom_form_text']) }}</div>
      </template>
    </form-factory>
    <lennoc-spinner v-show="busy" isFullscreen="false" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getFieldKeys } from '@/utils/formComposition'
import { getFormFields } from '@/utils/formFields'

export default {
  name: 'AccountDataEdit',
  methods: {
    saveSettings (record) {
      this.busy = true
      this.$store.dispatch('account/updateAccount', record).then(
        result => {
          this.$emit('end-edit-account', 'ok')
          this.busy = false
        },
        err => {
          this.$emit('edit-account-error', err)
          this.busy = false
          this.error = true
        }
      )
    },
    async checkAddress (fielddata) {
      this.localAccount[fielddata.field] = fielddata.value || ''

      if (this.localAccount.PostalCode && this.localAccount.HouseNumber) {
        if (
          this.localAccount.PostalCode !== this.chkPc ||
          this.localAccount.HouseNumber !== this.chkHn
        ) {
          this.chkPc = this.localAccount.PostalCode
          this.chkHn = this.localAccount.HouseNumber
          this.busy = true

          try {
            const result = await this.$store.dispatch('claim/findAddress', {
              postalCode: this.localAccount.PostalCode,
              houseNumber: this.localAccount.HouseNumber
            })

            if (result) {
              this.hasAddressError = false
              this.localAccount = {
                StreetName: result.Street || '',
                City: result.Town || ''
              }
            } else {
              this.hasAddressError = true
              this.localAccount = {
                StreetName: '',
                City: ''
              }
            }
          } catch (error) {
            console.error('Error during address lookup:', error)
            this.hasAddressError = true
          } finally {
            this.busy = false
          }
        }
      }
    }

  },
  data: function () {
    return {
      busy: false,
      error: false,
      layout: getFieldKeys('account'),
      chkPc: '',
      chkHn: '',
      hasAddressError: false,
      localAccount: null
    }
  },
  created () {
    if (this.account) {
      this.localAccount = { ...this.account }
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      account: 'account/shadowAccount'
    }),
    formFields () {
      const fields = getFormFields(this.layout)
      fields.EMailAddress.disabled = true
      return fields
    }
  }
}
</script>
